import { useAuthStore } from '../stores/useAuthStore';
import { AuthData } from '../types/auth';

export function getAuthToken(): string | null {
    const { authData } = useAuthStore.getState();
    if (!authData) return null;

    return isAuthTokenExpired(authData) ? null : authData.accessToken;
}

export const isAuthTokenExpired = (authData: Pick<AuthData, 'expiredTime'> | null) => {
    if (!authData) return true;

    return new Date().getTime() > authData.expiredTime;
};
